<template>
  <div class="update-aso-form">
    <locale-step
      ref="localeForm"
      :init-model="selectedApplication"
      :hide-inputs="hideInputs"
      task-type="update_app"
      :aso-task-type="asoTaskType"
      @on-validated="handleLocaleFormValidate"/>
    <div class="update-aso-form__toolbar">
      <p-button :disabled="loading" type="info" @click="handleClickSaveBtn">
        <el-icon v-if="loading" class="is-loading">
          <Loading/>
        </el-icon>
        <span v-else>Создать</span>
      </p-button>
    </div>
  </div>
</template>

<script>
import LocaleStep from "@/components/Pages/Tasks/common/Steps/LocaleStep"
import {mapActions, mapGetters} from "vuex"

export default {
  name: "UpdateTextAsoForm",
  components: {LocaleStep},
  props: {
    asoTaskType: {
      type: String,
    },
  },
  data() {
    return {
      hideInputs: ['desktop_name'],
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['selectedApplication']),
  },
  methods: {
    ...mapActions({
      createUpdateTextTask: 'aso_manager/createUpdateTextTask',
      createUpdateImageTask: 'aso_manager/createUpdateImageTask',
    }),
    handleClickSaveBtn() {
      this.$refs['localeForm'].validate()
    },
    async handleLocaleFormValidate(...args) {
      const [isValid, model] = args
      const currentAction = this.asoTaskType === 'update_aso_text'
        ? this.createUpdateTextTask
        : this.createUpdateImageTask
      if (!isValid) return
      this.loading = true
      try {
        const {id, language, language_default} = this.selectedApplication
        const result = await currentAction({
          model,
          initModel: {
            id,
            language,
            language_default,
          },
        })
        if (result) {
          this.$emit('close', {reload: true})
        }
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style scoped>

</style>
